var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16732 3.33366V1.33366C4.16732 0.965472 4.4658 0.666992 4.83398 0.666992H10.1673C10.5355 0.666992 10.834 0.965472 10.834 1.33366V3.33366H13.5007C13.8689 3.33366 14.1673 3.63214 14.1673 4.00033V13.3337C14.1673 13.7019 13.8689 14.0003 13.5007 14.0003H1.50065C1.13246 14.0003 0.833984 13.7019 0.833984 13.3337V4.00033C0.833984 3.63214 1.13246 3.33366 1.50065 3.33366H4.16732ZM2.16732 10.667V12.667H12.834V10.667H2.16732ZM2.16732 9.33366H12.834V4.66699H2.16732V9.33366ZM5.50065 2.00033V3.33366H9.50065V2.00033H5.50065ZM6.83398 7.33366H8.16732V8.66699H6.83398V7.33366Z",
    fill: "#96999C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.2bc8709129381f6de7f18cb2071fe6fe.svg";
export { ForwardRef as ReactComponent };